// extracted by mini-css-extract-plugin
module.exports = {"Settings":"Settings_Settings__2WEZf","textField":"Settings_textField__36RLv"};